'use es6';

import I18n from 'I18n';
import { getIsPaymentsEnabled } from 'FormsUI/selectors/Payments';
import { getPaymentFieldFromFormDefinition } from 'FormsUI/selectors/FormDefinition';
import { updateFormValue } from 'FormsUI/actions/FormDefinition';
import { update as updateFieldAction } from 'FormsUI/actions/Field';
import { getFormsLangToLang } from 'FormsUI/utils/Lang';
import { i18nLookupAndText } from 'FormsUI/utils/FormFieldsUtils';
import { translate } from 'forms-utils-lib/language/translate';
import updateFormFieldKey from 'forms-utils-lib/formField/utils/updateFormFieldKey';
import FormFieldKeys from 'forms-utils-lib/constants/formField/FormFieldKeys';
const createAction = name => `@@formDefinition/${name}`;
export const START_TRANSLATE_PAYMENTS = createAction('START_TRANSLATE_PAYMENTS');
export const END_TRANSLATE_PAYMENTS = createAction('END_TRANSLATE_PAYMENTS');
const translatePayments = (oldLocale, newLocale) => (dispatch, getState) => {
  dispatch({
    type: START_TRANSLATE_PAYMENTS,
    oldLocale,
    newLocale
  });
  const state = getState();
  const isPaymentsEnabled = getIsPaymentsEnabled(state);
  const paymentField = getPaymentFieldFromFormDefinition(state);
  if (paymentField) {
    const oldLocaleOptions = {
      locale: getFormsLangToLang(oldLocale)
    };
    const originalLabelInFormLang = i18nLookupAndText('miscFormFieldLabels.paymentLink', oldLocaleOptions);
    const isOriginalPaymentLabel = paymentField.label === originalLabelInFormLang;
    if (isOriginalPaymentLabel) {
      const translatedLabel = translate(I18n, 'miscFormFieldLabels.paymentLink', {
        locale: newLocale
      });
      const translatedPaymentField = updateFormFieldKey(paymentField, FormFieldKeys.LABEL, translatedLabel);
      dispatch(updateFieldAction(translatedPaymentField));
    }
  }
  dispatch(updateFormValue({
    submitText: translate(I18n, isPaymentsEnabled ? 'defaultForm.continueToPayment' : 'defaultForm.submitLabel', {
      locale: newLocale
    })
  }));
  dispatch({
    type: END_TRANSLATE_PAYMENTS,
    oldLocale,
    newLocale
  });
};
export default translatePayments;